import React from 'react';
import { Link } from 'react-router-dom';

const links = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Contact', path: '/contact' },
];

export default function Footer() {
  return (
    <footer style={{
      background: '#0E2238',
      padding: 'clamp(20px,3vw,28px) clamp(20px,5vw,48px)',
      borderTop: '1px solid rgba(245,166,35,0.15)',
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <img src="/logo.jpeg" alt="Ensign Electrotech Logo" style={{ width: '38px', height: '38px', borderRadius: '6px', objectFit: 'cover', flexShrink: 0 }} />
          <div>
            <span style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(13px,1.5vw,15px)', fontWeight: 700, color: '#fff', display: 'block' }}>
              Ensign Electrotech LLP
            </span>
            <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '10px', color: 'rgba(255,255,255,0.4)', display: 'block', marginTop: '1px' }}>
              Reliable Power & Trusted Security
            </span>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 'clamp(12px,2vw,24px)', flexWrap: 'wrap' }}>
          {links.map(({ label, path }) => (
            <Link key={path} to={path} style={{ fontSize: '12px', color: 'rgba(255,255,255,0.45)', textDecoration: 'none', transition: 'color 0.2s' }}
              onMouseEnter={e => e.target.style.color = '#F5A623'}
              onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.45)'}>
              {label}
            </Link>
          ))}
        </div>

        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.3)' }}>
            © {new Date().getFullYear()} Ensign Electrotech LLP
          </div>
          <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.2)', marginTop: '2px' }}>
            MVP Colony, Vizag 530017 · 0891 462252
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          footer > div { flex-direction: column; align-items: center; text-align: center; }
          footer > div > div:last-child { text-align: center; }
        }
      `}</style>
    </footer>
  );
}
